/**
 * 创建人：zll
 * 时间：2020-10-28
 * 描述：开关组件封装（表示两种相互对立的状态间的切换，多用于触发「开/关」）
 * 使用说明: 参考 sw-switch 配置应用说明文档
 * 更新记录:
 *
 */
import { Component, OnInit, Input, ContentChild, TemplateRef, Output, EventEmitter, AfterViewInit, ViewChild, ElementRef} from '@angular/core';
declare var $: any;

@Component({
  selector: 'sw-switch',
  templateUrl: './sw-switch.component.html',
  styleUrls: ['./sw-switch.component.css']
})
export class SwSwitchTooltipComponent implements OnInit {

  /**
  * 开关是否为打开状态
  * 默认false 为关闭状态
  * @ignore
  */
 @Input() isActive: boolean = false
 /**
  * 开关是否为禁用状态
  * 默认false
  * @ignore
  */
 @Input() disabled: boolean = false
/**
  * 开关是否是可读状态
  * 默认true
  * @ignore
  */
 @Input() readonly: boolean = false

 /**
  * switch 开关打开时的文字描述
  * 默认文字为 是
  * @ignore
  */
 @Input() activeText: string = '是'
 /**
  * switch 开关关闭时的文字描述
  * 默认文字为 否
  * @ignore
  */
 @Input() inactiveText: string = '否'

 @Input() isOutJudge: boolean = true;

  /**
   * 开关切换后抛出事件
   */
  @Output() changeSwitch = new EventEmitter();

  constructor(private el: ElementRef,) { }

  ngOnInit() {

  }

   //switch 开关切换
   switch(event) {
    event.stopPropagation();
     if(!this.readonly){
      this.isActive = !this.isActive
      this.changeSwitch.emit(this.isActive)
     }
   }

}
